import supportsLocalStorage from "@secureo/common/utils/detection/supportsLocalStorage"

const localStorageKey = "hasCompletedTourGuide"

export const hasCompletedTourGuide = () => {
	if (supportsLocalStorage()) {
		const hasCompletedTourGuide = localStorage.getItem(localStorageKey) === "true"

		return hasCompletedTourGuide
	}

	return false
}

export const setHasCompletedTourGuide = () => {
	if (supportsLocalStorage()) {
		localStorage.setItem(localStorageKey, "true")
	}
}
